<template>
  <div class="frameParent">
    <div class="yourCurriculumWrapper">
      <b class="yourCurriculum">Your Curriculum</b>
    </div>
    <div class="row" style="width: 100%">
      <div class="frameGroup col-sm-4" v-for="(curriculum, i) in curriculums" :key=i>
        <div class="frameContainer" @click="onFrameContainerClick(curriculum)">
          <div class="frameWrapper" :style="'background-color: ' + (curriculum.backgroundColor ? curriculum.backgroundColor : '#000')">
            <div class="frame">
              <img
                class="frameChild"
                alt=""
                :src="curriculum.logoURL ? curriculum.logoURL : '/static/img/HiloLogo.png' "
              />
            </div>
          </div>
          <div class="commercialPilot2024Parent">
            <b class="yourCurriculum">{{ curriculum.name }}</b>
          </div>
        </div>
      </div>
    </div>
    <div class="yourCurriculumWrapper">
      <b class="yourCurriculum">Create Curriculum</b>
    </div>
    <div class="frameGroup">
      <div class="frameContainer" @click="toggleOpenCreateCurriculum">
        <div class="frameWrapper" style="background-color: white">
          <div class="frame">
            <img
              class="createLogo"
              alt=""
              src="/static/img/grey-circle-plus.svg"
            />
            <div class="createText">
              Create Curriculum
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-curriculum-modal
      :isVisible="openCreateCurriculum"
      :currentCurriculums="curriculums"
      @close="toggleOpenCreateCurriculum"
      @create="createNewCurriculum"
    ></create-curriculum-modal>
    <toast-notifier ref="toast"></toast-notifier>
  </div>
</template>
<script>
import { getProcessedImageUrl } from "../../../../util/images";
import toastNotifier from "../../../../components/ToastNotifier.vue";
import CreateCurriculumModal from "./CreateCurriculumModal.vue";
import CurriculumsAPIService from "@/servicehandlers/CurriculmsAPIService.js";

const curriculumAPI = new CurriculumsAPIService()
export default {
  name: "Frame",
  components: {
    CreateCurriculumModal,
    toastNotifier
  },
  data() {
    return {
      curriculums: [],
      openCreateCurriculum: false,
    }
  },
  methods: {
    getProcessedImageUrl,
    onFrameContainerClick(curriculum) {
      this.$router.push({
        name: 'Course Details',
        query: { curriculumId: curriculum.id },
      });

    },
    async getAllCurriculums() {
      this.curriculums = await curriculumAPI.getAllCurriculums()
      for (let curriculum of this.curriculums){
        curriculum.logoURL = this.getProcessedImageUrl(curriculum.logoURL)
      }
    },
    toggleOpenCreateCurriculum(){
      this.openCreateCurriculum = !this.openCreateCurriculum
    },
    createNewCurriculum(curriculum){
      return curriculumAPI.createCurriculum(curriculum, this.$router)
        .then(response => {
          if (curriculum.logo) {
            const formData = new FormData();
            formData.append("image", curriculum.logo);
            return curriculumAPI.updateCurriculumLogo(response.id, formData)
              .then(() => {
                this.getAllCurriculums()
                this.toggleOpenCreateCurriculum()
              })
              .catch(e => {
                this.$refs.toast.showError("Error while uploading curriculum logo")
                this.getAllCurriculums()
                this.toggleOpenCreateCurriculum()
              })
          } else {
            this.getAllCurriculums()
            this.toggleOpenCreateCurriculum()
          }
        })
    }
  },
  async mounted() {
    await this.getAllCurriculums()
  }
};
</script>
<style scoped>
.yourCurriculum {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.createText{
  color: #a0a0a0;
  font-size: 24px;
}
.yourCurriculumWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
}
.frameChild {
  position: relative;
}

.createLogo{
  width: 40px;
  position: relative;
}
.frame {
  position: absolute;
  top: 50%;
  left: 50%;
  webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 261px;
  height: 55px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.frameWrapper {
  align-self: stretch;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  height: 125px;
  overflow: hidden;
  flex-shrink: 0;
}
.commercialPilot2024Parent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0 10px;
}
.frameContainer {
  width: 339.3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  cursor: pointer;
}
.frameGroup {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 30px;
  font-size: 15px;
}
.frameParent {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 200px;
  box-sizing: border-box;
  gap: 15px;
  text-align: left;
  font-size: 25px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
